import { GOOGLE_TOS_ACCEPTED } from "constants/storageKeys";

export const getGoogleTosConsent = (): boolean => {
  try {
    return sessionStorage.getItem(GOOGLE_TOS_ACCEPTED) === "true";
  } catch (error) {
    console.warn("Failed to read terms of service consent:", error);
    return false;
  }
};
